import React from 'react';
import { getCtaUrl } from '../../../utils';
import Link from '../Link';
import './index.scss';

const LinkItem = ({ link, label, isButton, extraClass }) => {
  return (
    <li className={`main-link nav-item ${extraClass ? extraClass : ''}`}>
      <Link to={getCtaUrl(link)} className={isButton ? 'btn btn-primary' : ''}>
        {label}
      </Link>
    </li>
  );
};

export default LinkItem;
